module.exports = __webpack_public_path__ + "img/few_bridge.38862b34.png";